export default __webpack_public_path__ + "static/shabbat-guide-42458d16a994e5c6e1cd6df43e11c1ee.png";